var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallblob3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191.997,
    height: 183.41,
    viewBox: "0 0 191.997 183.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M142.144,20.008c13.48,14.565,29.333,40.139,27.256,59.816s-22.112,33.49-35.592,52.858-31.081,40.5-49.272,41.091S47.568,154.4,30.8,135.037c-16.8-19.368-14.035-38.472-13.23-56.414.837-17.942-.25-34.754,16.515-49.319C50.883,14.74,64.5,14.961,83.929,12.637s44.736-7.193,58.216,7.371",
    transform: "matrix(-0.208, -0.978, 0.978, -0.208, 25.523, 202.011)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallblob3);
export default __webpack_public_path__ + "static/media/smallblob3.a241ae7f53ba9c847244b0893ee9b4ce.svg";
export { ForwardRef as ReactComponent };